export default __webpack_public_path__ + "static/media/back.c4a8eb47.jpeg";